import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import type { UserRole } from '@/types'

interface AuthExtras {
  userId?: string
  email?: string
  tenantId?: string
  tenantSlug?: string
  allowedEndpoints?: string[] | null
  permissionsConfigured?: boolean
  effectiveEndpoints?: string[]
}

interface AuthState extends AuthExtras {
  role: UserRole | null
  roleName: string
  isAuthenticated: boolean
  setAuth: (role: UserRole, roleName: string, extras?: AuthExtras) => void
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      role: null,
      roleName: '',
      isAuthenticated: false,
      userId: undefined,
      email: undefined,
      tenantId: undefined,
      tenantSlug: undefined,
      setAuth: (role, roleName, extras) =>
        set({
          role,
          roleName,
          isAuthenticated: true,
          userId: extras?.userId,
          email: extras?.email,
          tenantId: extras?.tenantId,
          tenantSlug: extras?.tenantSlug,
          allowedEndpoints: extras?.allowedEndpoints,
          permissionsConfigured: extras?.permissionsConfigured,
          effectiveEndpoints: extras?.effectiveEndpoints,
        }),
      clearAuth: () =>
        set({
          role: null,
          roleName: '',
          isAuthenticated: false,
          userId: undefined,
          email: undefined,
          tenantId: undefined,
          tenantSlug: undefined,
          allowedEndpoints: undefined,
          permissionsConfigured: undefined,
          effectiveEndpoints: undefined,
        }),
    }),
    {
      name: 'truemark-auth',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
